module.exports = __webpack_public_path__ + "static/media/groomingPageHairIcon.ec16877a.png";